import { render, staticRenderFns } from "./WorkflowManage.vue?vue&type=template&id=4ab794f5&scoped=true&"
import script from "./WorkflowManage.vue?vue&type=script&lang=js&"
export * from "./WorkflowManage.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowManage.vue?vue&type=style&index=0&id=4ab794f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab794f5",
  null
  
)

export default component.exports